import { useSuspenseQuery } from '@connectrpc/connect-query'
import { useTranslation } from 'react-i18next'

import { listBillingEmails } from '~/gen/proto/bff/v1/admin-BffAdminService_connectquery'
import { BillingEmail } from '~/gen/proto/bff/v1/model_pb'

/**
 * 全体送付先 (productId=0) + プロダクト個別送付先の一覧を取得する。
 * 全体送付先を先頭に、その後はプロダクトID昇順で並んだ配列が返る。
 */
export function useBillingEmails(organizationId: string): BillingEmail[] {
  const { t } = useTranslation()

  const res = useSuspenseQuery(
    listBillingEmails,
    { organizationId },
    {
      select: (data) => data.billingEmails,
    },
  )
  if (res.isError || res.data === undefined) {
    throw new Error(t('message.fetchFail', { entity: t('domain.billing') }))
  }
  return res.data
}
